export const animate = ({
  sourceElement = null, scale = 1, source = '', targetElement = null, target = '', show = false, display = 'block', property = 'transform',
  duration = 1000, easing = 'linear', delay = 0, onFinish = () => { }, onError = () => { },
}) => {
  sourceElement = sourceElement || (source && document.querySelector(source));
  targetElement = targetElement || (target && document.querySelector(target));

  if (!sourceElement || !targetElement) {
    onError('sourceElement or targetElement不存在');
    return;
  }

  if (show) {
    sourceElement.style.display = display;
  }
  sourceElement.style.transition = `${property} ${duration}ms ${easing} 0`;
  const sourceRect = sourceElement.getBoundingClientRect();
  const sourceStyle = window.getComputedStyle(sourceElement);
  const targetRect = targetElement.getBoundingClientRect();

  const { left, top } = sourceStyle;

  const deltaX = sourceRect.left - targetRect.left - (targetRect.width - sourceRect.width) / 2;
  const deltaY = sourceRect.top - targetRect.top - (targetRect.height - sourceRect.height) / 2;

  sourceElement.style.left = `${parseInt(sourceStyle.left, 10) - deltaX}px`;
  sourceElement.style.top = `${parseInt(sourceStyle.top, 10) - deltaY}px`;

  sourceElement.style.transitionDuration = '0ms';
  sourceElement.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

  setTimeout(() => {
    requestAnimationFrame(() => {
      sourceElement.style.transitionDuration = `${duration}ms`;
      sourceElement.style.transform = `scale(${scale})`;
    });
  }, delay);

  sourceElement.addEventListener('transitionend', () => {
    sourceElement.style.transition = '';
  });

  setTimeout(() => {
    sourceElement.style.display = 'none';
    sourceElement.style.left = left;
    sourceElement.style.top = top;
    sourceElement.style.transitionDuration = '';
    onFinish();
  }, duration + delay * 2);
};

export default animate;
